import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3l5 3v12l-5 3l-10 -6v-6l10 6v-6l-5 -3l5 -3","key":"svg-0"}],["path",{"d":"M12 6l-5 -3l-5 3v12l5 3l4.7 -3.13","key":"svg-1"}]]

/**
 * IconBrandNexo
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtbmV4byIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTcgM2w1IDN2MTJsLTUgM2wtMTAgLTZ2LTZsMTAgNnYtNmwtNSAtM2w1IC0zIiAvPgogIDxwYXRoIGQ9Ik0xMiA2bC01IC0zbC01IDN2MTJsNSAzbDQuNyAtMy4xMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-nexo
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandNexo = createReactComponent('outline', 'brand-nexo', 'BrandNexo', __iconNode);

export default IconBrandNexo;